import { viewportHeight as layoutViewportHeight, viewportWidth as layoutViewportWidth } from "../../utils/displayDensity";
import { SkeletonBox, SkeletonStyles } from "./SkeletonLoader";
import { useState, useEffect } from "react";

const SkeletonMobileMindshare = ({ gamesCount = 20 }) => {
  const [visibleGamesCount, setVisibleGamesCount] = useState(gamesCount);

  const calculateVisibleCount = () => {
    const CARD_HEIGHT = 180;
    const CARD_WIDTH = 160;
    const GRID_COL_GAP = 16;
    const HEADER_HEIGHT = 100;

    const availableHeight = layoutViewportHeight() - HEADER_HEIGHT;
    const rowCount = Math.ceil(availableHeight / CARD_HEIGHT) + 1;
    const cardsPerRow = Math.max(
      1,
      Math.floor((layoutViewportWidth() - 240) / (CARD_WIDTH + GRID_COL_GAP))
    );
    return rowCount * cardsPerRow;
  };

  useEffect(() => {
    const handleResize = () => {
      setVisibleGamesCount(calculateVisibleCount());
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={styles.container}>
      <SkeletonStyles />

      <div style={styles.sidebar}>
        <SkeletonBox
          width="120px"
          height="20px"
          borderRadius="4px"
          style={{ marginBottom: "20px" }}
        />

        <SkeletonBox
          width="100%"
          height="40px"
          borderRadius="8px"
          style={{ marginBottom: "15px" }}
        />

        <SkeletonBox
          width="100%"
          height="40px"
          borderRadius="8px"
          style={{ marginBottom: "15px" }}
        />
        <SkeletonBox
          width="100%"
          height="40px"
          borderRadius="8px"
          style={{ marginBottom: "15px" }}
        />
      </div>

      <div style={styles.mainContent}>
        <SkeletonBox
          width="200px"
          height="24px"
          borderRadius="6px"
          style={{ marginBottom: "20px" }}
        />

        <div style={styles.gamesGrid}>
          {Array.from({ length: visibleGamesCount }).map((_, index) => (
            <div key={index} style={styles.gameCard}>
              <SkeletonBox
                width="100%"
                height="100px"
                borderRadius="10px"
                style={{ marginBottom: "8px" }}
              />

              <SkeletonBox
                width="90%"
                height="16px"
                borderRadius="4px"
                style={{ marginBottom: "8px" }}
              />

              <SkeletonBox
                width="60%"
                height="14px"
                borderRadius="4px"
                style={{ marginBottom: "8px" }}
              />

              <div style={styles.progressBar}>
                <SkeletonBox
                  width={`${30 + (index % 4) * 20}%`}
                  height="6px"
                  borderRadius="4px"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    background: "#000",
    color: "#fff",
    minHeight: "calc(var(--mg-vh) * 100)",
  },
  sidebar: {
    position: "sticky",
    top: 0,
    height: "calc(var(--mg-vh) * 100)",
    overflowY: "auto",
    padding: "20px",
    background: "#111",
    borderRight: "1px solid #333",
    width: "260px",
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  mainContent: {
    flex: 1,
    padding: "20px",
  },
  gamesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
    gap: "16px",
  },
  gameCard: {
    background: "#111",
    padding: "10px",
    borderRadius: "12px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  progressBar: {
    width: "100%",
    height: "6px",
    background: "#333",
    borderRadius: "4px",
    overflow: "hidden",
  },
};

export default SkeletonMobileMindshare;
